import Modal from '@/components/Modal'
import { Typography } from '@mui/material'
import { SaveButton, SimpleForm, TextInput, Toolbar } from 'react-admin'
import { FieldValues } from 'react-hook-form'
import { useInvite } from '../hooks/useInvite'

const styles = {
  container: {
    width: '450px',
    padding: '16px'
  },
  input: {
    marginBottom: 2
  },
  title: {
    marginBottom: 2
  }
}

export type Props = {
  open: boolean
  onClose: () => void
  onInviteSuccess?: () => void
}

const FormButtons = () => (
  <Toolbar>
    <SaveButton label="Invite" icon={<></>} />
  </Toolbar>
)

export const InviteUser = ({ open, onClose, onInviteSuccess }: Props) => {
  const { invite } = useInvite({
    onInviteSuccess: () => {
      onClose()
      onInviteSuccess?.()
    }
  })

  const handleSubmit = (values: FieldValues) => {
    invite({
      firstName: values.firstName,
      lastName: values.lastName,
      email: values.email
    })
  }

  return (
    <Modal open={open} onClose={onClose} maxWidth="sm" styles={styles}>
      <SimpleForm
        data-testid="invite-user-form"
        onSubmit={handleSubmit}
        toolbar={<FormButtons />}
      >
        <Typography variant="h6" gutterBottom sx={styles.title}>
          Invite New User
        </Typography>
        <TextInput
          source="firstName"
          label="First Name"
          inputProps={{ 'data-testid': 'first-name' }}
          isRequired
          fullWidth
          sx={styles.input}
        />
        <TextInput
          source="lastName"
          label="Last Name"
          inputProps={{ 'data-testid': 'last-name' }}
          isRequired
          fullWidth
          sx={styles.input}
        />
        <TextInput
          source="email"
          label="Email"
          type="email"
          inputProps={{ 'data-testid': 'email' }}
          isRequired
          fullWidth
          sx={styles.input}
        />
      </SimpleForm>
    </Modal>
  )
}
